import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { Announcement } from '../../../types/announcement.types';
import { AnnouncementMessage } from './AnnouncementMessage/AnnouncementMessage';

interface GoAnnouncementsDrawerProps {
    announcements: Announcement[];
}

const Announcements: React.FC<GoAnnouncementsDrawerProps> = ({ announcements }) => (
    <Stack direction="column">
        <Stack marginBottom="8">
            <Stack marginTop={{ default: '10', sm: '14' }}>
                <Heading color="white" size="h_lg" style={{ fontFamily: `PowerGrotesk, ${theme.fontFamily.primary}` }}>
                    What’s new?
                </Heading>
            </Stack>
        </Stack>
        <Stack direction="column" gap="6">
            {announcements.map((announcement, index) => (
                <AnnouncementMessage key={index} {...announcement} />
            ))}
        </Stack>
    </Stack>
);

export default Announcements;
